import { render, staticRenderFns } from "./SalesDeliveryForm.vue?vue&type=template&id=552c1a35&"
import script from "./SalesDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./SalesDeliveryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports